import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../typings/theme';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export default makeStyles((theme: ITheme) => ({
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  btnSave: {
    backgroundColor: 'gray',
    color: 'white',
  },
  btnPublish: {
    backgroundColor: '#78001b',
    color: 'white',
  },
  inputLabel: {
    fontSize: 12,
    marginTop: 15,
    marginLeft: 0,
  },
  textField: {
    marginTop: 13,
  },
  marginDefault: {
    margin: theme.spacing(0),
  },
  marginText: {
    fontSize: 12,
    marginTop: 4,
    marginLeft: theme.spacing(1),
  },
  labelCenter: {
    fontSize: 10,
    marginTop: 15,
    textAlign: 'center',
  },
  paper: {
    height: 'auto',
    display: 'grid',
    marginTop: 24,
    padding: 16,
    fontSize: 16,
    fontWeight: 600,
    textAlign: 'center',
  },
  menuProps: {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        display: 'flex',
        flexWrap: 'wrap',
      },
    },
    '& .MuiSelect-selectMenu': {
      whiteSpace: 'pre-wrap',
      textAlign: 'left',
    },
  },
}));
